module.exports = __webpack_public_path__ + "fonts/FSSinclair-Bold.b79b832f.otf";